<template>
  <div class="bx-flooding bx-flooding--footer">
    <footer class="bx-footer bx-typo--footer">
      <div class="bx-footer__wrapper">
        <div class="bx-grid">
          <NewsletterSubscription usage="footer"
                                  headline="Jede Woche aktuelle TV Movie-News zu TV, Kino oder Streaming!" />
          <SeoHeadline />
          <FooterAboTeaser :cover-url="coverUrl" />
          <SocialLinks menu-type="footer"
                       :brand="brand" />
        </div>
      </div>

      <div class="bx-footer__menu">
        <div class="bx-grid">
          <MenuList :menu="footerData.menu"
                    menu-type="footer" />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'pinia'

import { usePageStore } from '../../../stores/page'
import MenuList from '../../../components/menu/MenuList.vue'
import SeoHeadline from '../../../components/page-footer/SeoHeadline.vue'
import NewsletterSubscription from '../../../components/shared/NewsletterSubscription.vue'
import SocialLinks from '../../../components/shared/SocialLinks.vue'
import FooterAboTeaser from './FooterAboTeaser.vue'

export default {
  components: {
    MenuList,
    SeoHeadline,
    SocialLinks,
    NewsletterSubscription,
    FooterAboTeaser
  },
  props: {
    footerData: {
      type: Object,
      default: () => { return {} }
    },
    brand: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      vodEpgSliders: []
    }
  },
  computed: {
    ...mapState(usePageStore, ['pageData']),
    coverUrl () {
      return `${process.env.COVER_URL}${this.brand.toLowerCase()}.jpg`
    }
  },
  beforeMount () {
    this.addTmdbDisclaimer()
  },
  mounted () {
    this.vodEpgSliders = document.querySelectorAll('.bx-teaser-container--vod-epg-slider')
    /*
      Unfortunately, we have to resort to some tricks with the vodEpgTeaserGroupSlider,
      as we need a flexbox to ensure that the background color in the teaser content is
      displayed evenly when the texts are of different lengths.

      The problem, however, is that if we give the slider cells a height, whatever the value,
      the entire slider collapses in height and the content is not accessible or displayed.

      For this reason, there is a workaround for TVM (as it is design-based) by bringing the
      smaller content blocks to the same height as the largest cell(s) and adjusting this when resize.
     */
    if (this.vodEpgSliders.length) {
      window.addEventListener('resize', this.setEqualTeaserHeights)
      document.addEventListener('DOMContentLoaded', this.setEqualTeaserHeights)
    }
  },
  beforeUnmount () {
    if (this.vodEpgSliders.length) {
      window.removeEventListener('resize', this.setEqualTeaserHeights)
      document.removeEventListener('DOMContentLoaded', this.setEqualTeaserHeights)
    }
  },
  methods: {
    setEqualTeaserHeights () {
      const sliders = document.querySelectorAll('.bx-teaser-container--vod-epg-slider')

      sliders.forEach(slider => {
        const teasers = slider.querySelectorAll('.bx-teaser__content')
        if (!teasers.length) return

        // Find the highest height within the respective slider
        let maxHeight = 0
        teasers.forEach(teaser => {
          // reset to measure real height
          teaser.style.height = 'auto'
          maxHeight = Math.max(maxHeight, teaser.offsetHeight)
        })

        // Apply the highest height within this slider
        teasers.forEach(teaser => {
          teaser.style.height = `${maxHeight - 16}px`
        })
      })
    },
    addTmdbDisclaimer () {
      const pageIsVodOrEpg = document.querySelector('.bx-page-style--tvm-epg, .bx-page-style--tvm-vod')
      // Ensure the page is either VOD or EPG and has pageType 'article', otherwise return
      if (!(pageIsVodOrEpg && this.pageData.pageMeta.pageType === 'article')) return

      const tmdbDisclaimer = document.querySelector('.bx-tmdb-disclaimer')
      // prevent adding multiple TMDB disclaimers
      if (tmdbDisclaimer) {
        tmdbDisclaimer.remove()
      }
      // Add TMDB disclaimer to the end of the paragraph list
      const container = document.querySelector('.bx-paragraph-list')
      const htmlBlock = `
        <div class="bx-content bx-content__continuous-text bx-typo--content-continuous-text bx-tmdb-disclaimer">
          <p>
            <svg class="tmdb-icon"><use href="/images/tvmovie/tmdb-logo.svg#tmdb-logo"></use></svg>
            TV Movie verwendet TMDB und die TMDB-APIs, wird jedoch nicht von TMDB unterstützt, zertifiziert oder anderweitig genehmigt.
          </p>
        </div>
      `
      container.insertAdjacentHTML('beforeend', htmlBlock)
    }
  }
}
</script>
